import md5 from 'blueimp-md5';

/**
 * Returns a Gravatar URL for the given email address.
 *
 * Falls back to `d=mp` (mystery-person silhouette) when no Gravatar is registered,
 * so the URL always resolves to an image. HeroUI's Avatar `name` prop still provides
 * the initials layer beneath, visible before the image loads.
 *
 * @param email - The user's email address.
 * @param size  - Pixel size of the avatar (default 80 — enough for 2× on small avatars).
 */
export function gravatarUrl(email: string, size = 80): string {
  const hash = md5(email.trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=mp`;
}
